"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _isEqual2 = _interopRequireDefault(require("lodash-es/isEqual"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _list = require("../list");

var _checkbox = _interopRequireDefault(require("../../atoms/checkbox"));

var _radio = _interopRequireDefault(require("../../atoms/radio"));

var _heading = _interopRequireDefault(require("../../atoms/heading"));

var _stack = _interopRequireDefault(require("../stack"));

var _validations = require("../../_utils/validations");

var _versions = require("../../_utils/versions");

var _tokens = require("../../../tokens");

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject5() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ":first-child {\n    border-top: none;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      background: ", ";\n      font-weight: ", ";\n      opacity: 1;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 8px 12px;\n  cursor: ", ";\n  opacity: ", ";\n  border-top: ", ";\n  pointer-events: ", ";\n  &:hover {\n    background: ", "\n  }\n  &:active {\n      font-weight: ", ";\n      {Icon.Element} path {\n        fill: ", ";\n      }\n    };\n  ", " {\n    margin: 0\n  }\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  width: 85%;\n  span {\n    padding: 0;\n    width: 100%;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColors = function getColors(props) {
  return (0, _versions.getColor)(props, 'list');
};

var Row = _list.StyledRow.extend(_templateObject());

var ListItem = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.selected && props.styleSelected ? 'default' : 'pointer';
}, function (props) {
  return props.selected ? 0.7 : 1;
}, function (props) {
  return props.bordered ? "1px solid ".concat(getColors(props).borderColor) : null;
}, function (props) {
  return props.selected && props.styleSelected ? 'none' : 'auto';
}, function (props) {
  return !props.styleSelected ? getColors(props).backgroundHover : !props.selected ? getColors(props).backgroundHover : null;
}, _tokens.fonts.weight.semiBold, function (props) {
  return getColors(props).activeText;
}, _radio["default"].RadiosNavigation, function (props) {
  return props.selected && (0, _styledComponents.css)(_templateObject3(), function (props) {
    return getColors(props).backgroundHover;
  }, _tokens.fonts.weight.bold);
});

var List = _list.StyledList.extend(_templateObject4(), ListItem);

var SelectableList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectableList, _React$Component);

  //eslint-disable-line
  function SelectableList(props) {
    var _this;

    _classCallCheck(this, SelectableList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectableList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value) {
      if (_this.props.multi) {
        if (_this.state.values.includes(value)) {
          _this.setState(function (prevState) {
            return {
              values: prevState.values.filter(function (v) {
                return v !== value;
              })
            };
          }, _this.onSelection);
        } else {
          _this.setState(function (prevState) {
            return {
              values: [].concat(_toConsumableArray(prevState.values), [value])
            };
          }, _this.onSelection);
        }
      } else {
        _this.setState({
          values: value
        }, _this.onSelection);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSelection", function () {
      _this.props.onChildSelection();

      _this.props.onSelection(_this.state.values);
    });

    _defineProperty(_assertThisInitialized(_this), "isSelected", function (value) {
      var multi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (_this.state.values) {
        return multi ? _this.state.values.includes(value) : _this.state.values === value;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      if (!(0, _isEqual2["default"])(nextProps.selected, _this.props.selected)) {
        _this.setState({
          values: nextProps.selected
        });
      }
    });

    _this.state = {
      values: props.multi ? !(0, _validations.isNil)(props.selected) ? props.selected : [] : !(0, _validations.isNil)(props.selected) ? props.selected : ''
    };
    return _this;
  }

  _createClass(SelectableList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var validChildren = _react["default"].Children.toArray(this.props.children).filter(function (child) {
        return child;
      });

      return _react["default"].createElement(List, this.props, this.props.label && _react["default"].createElement(_list.StyledLabel, null, _react["default"].createElement(_heading["default"], {
        size: 4
      }, this.props.label)), _react["default"].Children.map(validChildren, function (child) {
        return _react["default"].createElement(ListItem, {
          selected: !_this2.props.multi ? child.props.value === _this2.state.values : false,
          bordered: _this2.props.bordered,
          styleSelected: _this2.props.styleSelected,
          onClick: function onClick() {
            return _this2.onSelect(child.props.value);
          },
          version: _this2.props.version
        }, _react["default"].createElement(_stack["default"], {
          align: "left"
        }, _this2.props.multi && !(0, _validations.isNil)(child.props.value) && _react["default"].createElement(_checkbox["default"], {
          checked: _this2.isSelected(child.props.value),
          onToggle: function onToggle() {
            return _this2.onSelect(child.props.value);
          }
        }), _this2.props.radioed && !_this2.props.multi && !(0, _validations.isNil)(child.props.value) && _react["default"].createElement(_radio["default"], {
          key: _this2.state.values,
          readOnly: true
        }, _react["default"].createElement(_radio["default"].Radio, {
          value: child.props.value,
          checked: _this2.isSelected(child.props.value, false)
        })), _react["default"].createElement(Row, _extends({}, _this2.props, {
          bordered: false
        }), child)));
      }));
    }
  }]);

  return SelectableList;
}(_react["default"].Component);

SelectableList.Item = _styledComponents["default"].div(_templateObject5());
SelectableList.propTypes = {
  /** header */
  label: _propTypes["default"].string,

  /** multiple selection */
  multi: _propTypes["default"].bool,

  /** default selected */
  selected: _propTypes["default"].any,

  /** onClick function */
  onSelection: _propTypes["default"].func,

  /** indication to adjust padding and margin */
  lean: _propTypes["default"].bool,

  /** Show radio in case of single select */
  radioed: _propTypes["default"].bool,

  /** bordered flag */
  bordered: _propTypes["default"].bool,

  /** use styles for selected item */
  styleSelected: _propTypes["default"].bool
};
SelectableList.defaultProps = {
  multi: false,
  selected: null,
  onSelection: _noop2["default"],
  lean: false,
  radioed: false,
  onChildSelection: _noop2["default"],
  bordered: false,
  styleSelected: true
};
SelectableList.displayName = 'SelectableList';

var _default = (0, _context.withVersion)(SelectableList);

exports["default"] = _default;